import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import LanguageSwitcher from "../components/LanguageSwitcher";

export default function CheckEmail() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  return (
    <div
      className="flex min-h-screen flex-col bg-gray-100 text-sm text-[#616262]"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      {/* Top bar */}
      <div className="border-b border-gray-200 bg-white py-4">
        <div className="z-20 mx-auto flex w-full max-w-6xl items-center justify-between px-6">
          <div className="flex w-full items-center justify-between gap-4 sm:w-auto sm:justify-start">
            {/* Logo */}
            <img
              onClick={() => navigate("/auth/landing")}
              src="/logo-blue.svg"
              alt="Logo"
              className="h-10 w-auto cursor-pointer sm:h-8 ltr:pr-3 rtl:pl-3"
            />
          </div>
          {/* <LanguageSwitcher defaultTheme /> */}
        </div>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <div className="flex w-full max-w-lg flex-col items-center justify-center rounded-xl border border-gray-200 bg-white p-8 shadow-lg">
          <h1 className="mb-4 text-2xl font-bold text-purple-500">{t("checkEmailTitle")}</h1>
          <p className="text-center text-gray-600">
            {t("checkEmailMessage")} <strong>{email}</strong>. {t("followEmailInstructions")}
          </p>
          <button
            onClick={() => navigate("/auth/login")}
            className="mt-6 rounded-full bg-purple-500 px-6 py-3 font-semibold text-white hover:bg-purple-800"
          >
            {t("backToLogin")}
          </button>
        </div>
      </div>
      {/* Footer Logos */}
      <footer dir="ltr" className="mt-auto border-t border-gray-200 bg-white py-1">
        <div className="flex flex-wrap items-center justify-center gap-6">
          <a href="https://modee.gov.jo" target="_blank" rel="noopener noreferrer">
            <img
              src="/Modee2.png"
              alt="Modee"
              className="h-16 w-[75px] object-contain opacity-90 transition hover:opacity-100 sm:h-20"
            />
          </a>

          <a href="https://cpf.jo" target="_blank" rel="noopener noreferrer">
            <img
              src="/CPF2.png"
              alt="CPF"
              className="h-20 w-20 object-contain opacity-90 transition hover:opacity-100 sm:h-20"
            />
          </a>
          <a href="https://ytj.jo" target="_blank" rel="noopener noreferrer">
            <img
              src="/YTJ2.png"
              alt="YTJ"
              className="h-20 w-20 object-contain opacity-90 transition hover:opacity-100 sm:h-20"
            />
          </a>
        </div>
        <div>
          <p className="text-center text-sm text-gray-600">
            &copy; {new Date().getFullYear()} Designed and developed by HWK
          </p>
        </div>
      </footer>
    </div>
  );
}
